import React, { FC } from 'react';
import { CommsCheckResult } from '../../types/comms-check';
import { InventoryDataSection } from './InventoryDataSection';
import { InstantaneousDataSection } from './InstantaneousDataSection';
import { OtherDevicesLogDataSection } from './OtherDevicesLogDataSection';

export interface CommsCheckFailResultProps {
  failScreenData: any;
  commsCheckData: CommsCheckResult;
}

export const CommsCheckFailResult: FC<CommsCheckFailResultProps> = ({ failScreenData, commsCheckData }) => {
  return (
    <div id="infoContainer" data-testid="info-panel-fail">
      <div className="informationPanel m-b-10">
        <div className="failInformationSection">
          <div className="m-b-10">
            <span className="resultKey">Result: </span>
            <span className="resultValue">{failScreenData.result}</span>
          </div>
          {failScreenData.information && <div className="informationHeading">{`${failScreenData.information}:`}</div>}
          {failScreenData.xrinvText && (
            <div className={'informationRow'} data-testid="xrinv-text-fail">
              <div className="informationSectionText">{failScreenData.xrinvText}</div>
            </div>
          )}
          {failScreenData.xritmText && (
            <div className="informationRow" data-testid="xritm-text-fail">
              <div className="informationSectionText">{failScreenData.xritmText}</div>
            </div>
          )}
          {failScreenData.xrdlgText && (
            <div className={'informationRow'} data-testid="xrdlg-text-fail">
              <div className="informationSectionText">{failScreenData.xrdlgText}</div>
            </div>
          )}
          <div className="informationRow" data-testid="action-fail-screen">
            <div className="informationHeading">Action To Take:</div>
            <div className="informationSectionText">{failScreenData.action}</div>
          </div>
          {(commsCheckData.xrinv.data.length >= 1 ||
            commsCheckData.xritm.data.length >= 1 ||
            commsCheckData.xrdlg.data.length >= 1) && (
            <div className="informationHeading" data-testid="info-devices-fail">
              Information:
            </div>
          )}
          {commsCheckData.xrinv.data.length >= 1 && <InventoryDataSection data={commsCheckData.xrinv.data} />}
          {commsCheckData.xritm.data.length >= 1 && <InstantaneousDataSection xritm={commsCheckData.xritm} />}
          {commsCheckData.xrdlg.data.length >= 1 && <OtherDevicesLogDataSection data={commsCheckData.xrdlg.data} />}
        </div>
      </div>
    </div>
  );
};
